
































import { Vue, Model, Prop, Component, Emit, Watch } from 'vue-property-decorator'
import { PagerData } from '@/libs/request/request'

import NormalTable from './table.vue'
import { TableDefine } from './type'

@Component({
  components: {
    NormalTable
  }
})
export default class OaPagerTable<T> extends Vue {
    @Model('change', { default: () => {
      return {
        total: 0,
        items: []
      }
    } })
    value!:PagerData<T>

    @Prop()
    readonly total!:number

    @Prop()
    readonly tableDefine!:TableDefine<T>

    @Prop({ default: false })
    readonly loading?:boolean

    @Prop({ default: false })
    readonly editable?:boolean

    @Prop({ default: true })
    readonly showElevator?:boolean

    @Prop({ default: true })
    readonly showSizer?:boolean

    /**
     * 编辑模式下，如果是inputMode,
     * 表示变更自动触发双向绑定
     */
    @Prop({ default: false })
    readonly inputMode?:boolean

    @Prop({ default: 1 })
    readonly page?:number

    @Prop({ default: 10 })
    readonly pageSize?:number

    @Prop({ default: true })
    readonly showPager?:boolean

    @Prop({
      default: () => {}
    })
    readonly onRowClick?:(row:any) => void

    @Prop({
      default: () => {}
    })
    readonly rowClassName?:(row:any) => void

    curPage:number = 1
    curPageSize:number = 10
    tableData:PagerData<T> = {
      total: 0,
      items: []
    }

    get tableRef () {
      return this.$refs.table as NormalTable<T>
    }

    @Watch('page')
    onWatchPage () {
      this.curPage = this.page || 1
    }

    @Watch('pageSize')
    onWatchPageSize () {
      this.curPageSize = this.pageSize || 10
    }

    @Watch('value')
    onWatchValue () {
      this.tableData = this.value
      const totalPage = Math.ceil(this.value.total / this.curPageSize)
      if (this.curPage > totalPage && totalPage > 0) {
        this.pageChange(totalPage)
      }
    }

    @Emit('change')
    onValueChange (newTableData:PagerData<T>) {
      return newTableData
    }

    pageChange (newPage:number) {
      const newValue = {
        pageSize: this.pageSize,
        page: newPage
      }
      this.$emit('update:page', newPage)
      this.$emit('pagerChange', newValue)
    }

    @Emit('update:pageSize')
    pageSizeChange (newPageSize:number) {
      this.curPageSize = newPageSize
      const newValue = {
        page: this.page,
        pageSize: newPageSize
      }
      this.$emit('update:pageSize', newPageSize)
      this.$emit('pagerChange', newValue)
    }

    created () {
      this.onWatchPageSize()
      this.onWatchValue()
    }

    public resetEditChange () {
      this.tableRef.resetEditChange()
    }

    public completeEditChange () {
      this.tableRef.completeEditChange()
    }

    public removeEditCol (index:number) {
      this.tableRef.removeEditCol(index)
    }
}
